"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var info_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/info"));
var check_circle_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/check_circle"));
var alert_triangle_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/alert_triangle"));
var alert_octagon_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/alert_octagon"));
var LftIconBase_1 = __importDefault(require("../LftIconBase"));
var LftHelper_styles_1 = require("./LftHelper.styles");
var LftHelper = function (_a) {
    var bgColor = _a.bgColor, className = _a.className, content = _a.content, dataTestId = _a.dataTestId, name = _a.name, _b = _a.status, status = _b === void 0 ? 'default' : _b, style = _a.style;
    var icons = {
        default: info_1.default,
        success: check_circle_1.default,
        error: alert_triangle_1.default,
        warning: alert_octagon_1.default,
    };
    return ((0, jsx_runtime_1.jsxs)(LftHelper_styles_1.HelperStyled, __assign({ bgColor: bgColor, className: className, "data-lift": "lft-helper", "data-testid": dataTestId, role: name ? 'alert' : 'contentinfo', id: name && name + '_helper', status: status, style: style }, { children: [(0, jsx_runtime_1.jsx)(LftIconBase_1.default, { ariaHidden: true, icon: icons[status], size: "sm" }, void 0), (0, jsx_runtime_1.jsx)(LftHelper_styles_1.HelperContent, { children: content }, void 0)] }), void 0));
};
exports.default = LftHelper;
